<template>
    <div class="review-wrapper p-4">
        <img :src="image" class="mw-100 rounded mb-4"/>
        <div class="text-center mb-4">{{ text_message }}</div>
    </div>
</template>

<script>
    export default {
        props: {
            image: String,
            text : {default: null},
        },

        computed: {
            text_message() {
                return this.text || 'Thank you!';
            }
        }
    }
</script>
